import { createStructuredSelector, createSelector } from 'reselect';
import { get, isEmpty } from 'lodash/fp';
import { selectManufacturerOptions } from 'store/ducks/manufacturers';
import { REDUCER_KEY as FUZZY_SEARCH_KEY } from './duck';

const getMakeModelSubtypeSuggestions = get([FUZZY_SEARCH_KEY, 'suggestions']);

const getSuggestions = createSelector(
  getMakeModelSubtypeSuggestions,
  selectManufacturerOptions,
  (makeModelSubtypeSuggestions, defaultSuggestions) => {
    if (!isEmpty(makeModelSubtypeSuggestions)) {
      return makeModelSubtypeSuggestions;
    }

    return defaultSuggestions;
  },
);

export default createStructuredSelector({
  suggestions: getSuggestions,
});
